import './App.css';

import RouterMain from './components/RouterMain';
import NavBarMain from './components/NavBarMain';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
   <div>
    {/* <NavBarMain/> */}
   
   <RouterMain/>
    
       </div>
  );
}

export default App;
